import { Check, Info } from "lucide-react";
import { useDietary } from "@/context/DietaryContext";

/** Small green-check-in-box badges. Shows ONLY applicable codes; hides the rest. */
export function DietaryBadges({ tags, size = "sm", testIdPrefix = "diet" }) {
  const { applicable } = useDietary();
  const apply = applicable(tags);
  if (!apply.length) return null;
  const isXs = size === "xs";
  return (
    <div className="flex flex-wrap gap-1" data-testid={`${testIdPrefix}-badges`}>
      {apply.map((d) => (
        <span
          key={d.code}
          data-testid={`${testIdPrefix}-${d.code}`}
          title={d.label}
          aria-label={d.label}
          className={`inline-flex items-center gap-1 rounded-md border bg-white ${
            isXs ? "px-1 py-0 text-[10px]" : "px-1.5 py-0.5 text-[11px]"
          } font-semibold tracking-wide`}
          style={{ color: d.color, borderColor: `${d.color}66` }}
        >
          <Check className={isXs ? "h-2.5 w-2.5" : "h-3 w-3"} strokeWidth={3} color={d.color} />
          {d.short}
        </span>
      ))}
    </div>
  );
}

export function DietaryLegend({ collapsed }) {
  const { legend } = useDietary();
  return (
    <details
      data-testid="dietary-legend"
      className="bg-white border border-[#E8E5DF] rounded-2xl overflow-hidden"
      open={!collapsed}
    >
      <summary
        data-testid="dietary-legend-toggle"
        className="px-5 py-4 cursor-pointer flex items-center gap-2 text-sm font-medium"
      >
        <Info className="h-4 w-4 text-[#5A7247]" strokeWidth={1.5} />
        Dietary legend
        <span className="ml-auto text-xs text-[#5C625E]">
          Only applicable icons are shown on each item.
        </span>
      </summary>
      <div className="px-5 pb-5 grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-3">
        {legend.map((d) => (
          <div
            key={d.code}
            data-testid={`legend-${d.code}`}
            className="flex items-center gap-2"
          >
            <span
              className="inline-flex items-center gap-1 rounded-md border bg-white px-1.5 py-0.5 text-[11px] font-semibold"
              style={{ color: d.color, borderColor: `${d.color}66` }}
            >
              <Check className="h-3 w-3" strokeWidth={3} color={d.color} />
              {d.short}
            </span>
            <span className="text-sm text-[#5C625E]">{d.label}</span>
          </div>
        ))}
      </div>
    </details>
  );
}
